module.exports = __webpack_public_path__ + "static/media/Giphy.2b220efc.gif";